import Swiper from './lib/swiper-bundle.min';

export default () => {
  const $swiperElement = document.getElementById('swiper-discover');
  if (!$swiperElement) return;

  let $swiperParameter = {
    speed: 1000,
    slidesPerView: 'auto',
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-discover-button-next",
      prevEl: ".swiper-discover-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  }

  new Swiper($swiperElement, $swiperParameter);

}
